import './SanityHeroSection.scss';
import { SanityHeroSectionProps } from './SanityHeroSection.types';
import { sanityDataset, sanityImagesBaseUrl, sanityProjectId } from '../../../../sanity.io/config';
import { useEffect, useState } from 'react';

const SanityHeroSection = ({ heroImageUrl }: SanityHeroSectionProps) => {
  const [img, setImg] = useState('');

  useEffect(() => {
    if (heroImageUrl) {
      setImg(heroImageUrl.split('image-')[1].replace('-jpg', '.jpg'));
    }
  }, [heroImageUrl]);

  return (
    <div className="sanity-hero-section">
      {img && (
        <section
          className="hero-section d-flex flex-column position-relative"
          style={{ background: `url(${sanityImagesBaseUrl}/${sanityProjectId}/${sanityDataset}/${img}) center center`, backgroundSize: 'cover' }}
        ></section>
      )}
    </div>
  );
};

export default SanityHeroSection;
